import { useState, useEffect } from "react";
import { saveDeduction, fetchWorkingDaysIds, fetchResourceIds } from "../Api/DeductionMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useAuth } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const DeductionMaster = () => {
  const [loading, setLoading] = useState(false);
  const [workingDaysIds, setWorkingDaysIds] = useState([]);
  const [resourceIds, setResourceIds] = useState([]);

  const { user } = useAuth();
  const navigate = useNavigate();

  const [deductionData, setDeductionData] = useState({
    workingDaysId: "",
    resourceId: "",
    deductionType: "",
    deductionAmount: "",
    payrollid: "",
    companycode: user?.companyCode,
    organisation_Id: user?.organisationId
  });

  const deductionTypes = ["TDS", "Advance", "Asset", "Leave"];

  useEffect(() => {
    const fetchIds = async () => {
      try {
        const [workingDays, resources] = await Promise.all([
          fetchWorkingDaysIds(user.organisationId),
          fetchResourceIds(user.organisationId)
        ]);

        setWorkingDaysIds(workingDays);
        setResourceIds(resources);
      } catch (err) {
        toast.error("Error loading IDs");
      }
    };

    fetchIds();
  }, []);

  const handleChange = (e) => {
    setDeductionData({
      ...deductionData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      ...deductionData,
      companycode: user.companyCode,
      organisation_Id: user.organisationId,
      deductionAmount: Number(deductionData.deductionAmount)
    };

    try {
      await saveDeduction(payload);
      toast.success("Deduction saved successfully!");
      navigate("/view-deductions");
    } catch (err) {
      toast.error(err.response?.data?.message || "Error saving data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Deduction Master</h2>

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Working Days ID</Form.Label>
                  <Form.Select
                    name="workingDaysId"
                    value={deductionData.workingDaysId}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Working Days ID</option>
                    {workingDaysIds.map((w) => (
                      <option key={w.workingDaysId} value={w.workingDaysId}>
                         {w.workingMonth}-{w.workingYear}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Resource ID</Form.Label>
                  <Form.Select
                    name="resourceId"
                    value={deductionData.resourceId}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Resource ID</option>
                    {resourceIds.map((r) => (
                      <option key={r.resourceId} value={r.resourceId}>
                        {r.resourceId} - {r.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Deduction Type</Form.Label>
                  <Form.Select
                    name="deductionType"
                    value={deductionData.deductionType}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Type</option>
                    {deductionTypes.map((t) => (
                      <option key={t} value={t}>{t}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Deduction Amount</Form.Label>
                  <Form.Control
                    type="number"
                    name="deductionAmount"
                    value={deductionData.deductionAmount}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button type="submit" variant="primary">Save Deduction</Button>
              <Button
                variant="secondary"
                className="ms-3"
                onClick={() => navigate("/viewdeductions")}
              >
                View Deductions
              </Button>
            </div>
          </Form>
        </Container>
      </div>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default DeductionMaster;
